<template>
  <div class="contractPage">
    <header v-if="showPageTitle" class="bar bar-nav">
        <h2>{{pageTitle}}</h2>
    </header>
    <div :class="['content-page', {'hide-page-title': !showPageTitle}]" v-html="pageData">
    </div>
    <div class="pageFooter"></div>
  </div>
</template>

<script>
  import api from "@/api";

  export default {
    name: "UserAgreement",
    props: {
      userAgreementType : {
        type: Number,
        default: -1
      },
      showPageTitle: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        pageData: '',
        pageTitle: ''
      }
    },
    watch: {
      userAgreementType: {
        async handler (val) {
            console.log(val)
            if(val) await this.initPage(val)
        },
        immediate: true
      }
    },
    methods: {
      async initPage (type) {
        const { success, data } = await api.user.getAgreementByType({
          userAgreementType: type
        })
        if (success && data) {
          this.pageData = data.content;
          this.pageTitle = data.title;
          document.title = `${this.pageTitle}|${document.title}`;
          // this.$store.commit('SET_PAGE_TITLE', this.pageTitle)
        }
      }
    }
  }
</script>

<style lang="less">
.contractPage {
  background: white;
  padding: 0;
  .f18 {
    font-size: .9rem;
  }
  .tc {
    text-align: center;
  }

  .bar {
    text-align: center;
    line-height: 0;
    background: #f0f0f0;
    & > h2 {
      font-size: 0.9rem;
      line-height: 2.2rem;
    }
  }

  .content-page {
    font-size: 0.8rem;
    position: absolute;
    top: 2.2rem;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0 0.75rem 0.75rem;
    background: white;
    overflow-x: hidden;
    overflow-y: auto;
    &.hide-page-title {
      top: 0;
    }

    .content {
      position: relative;
      top: 0;
      .content-block {
        margin: 0 !important;
        padding: 0 0.75rem 0.75rem !important;
        background: white !important;
      }
    }
    .page {
      background: white !important;
    }

    .pageHeader {
      margin: 10px 0;
    }
    p {
      margin: 10px 0;
    }
    .table {
      width: 100%;
      overflow-x: auto;
      border-collapse: collapse;
      border: 1px solid #ddd;
    }
    .table .th {
      padding: 8px;
      border: 1px solid #ddd;
    }
    .table .td {
      vertical-align: top;
      padding: 8px;
      border: 1px solid #ddd;
    }
    .table .th p,
    .table .td p {
      margin: 0;
    }
    .tableBox .table {
      width: 1200px;
      overflow-x: auto;
      border-collapse: collapse;
    }
    a {
      cursor: pointer;
    }
  }
}
.pageFooter {
  height: 45px;
}
</style>